exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".simple-table[data-v-7af002c1]{--custom-col-structure:repeat(calc(var(--cols) - 1),minmax(min-content,auto)) minmax(min-content,max-content)}", ""]);

// exports
